import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type TripListItem = ResultOf<
  typeof tripListQuery
>["trips"]["data"][number];
export const tripListQuery = graphql(`
  query TripList(
    $first: Int!
    $page: Int!
    $cityIds: [ID!]
    $order: [QueryTripsOrderRelationOrderByClause!]
  ) {
    trips(first: $first, page: $page, city_ids: $cityIds, order: $order) {
      data {
        id
        distance_kms
        duration_hrs
        faqs_count
        cityA {
          id
          name
          lat
          lng
        }
        cityB {
          id
          name
          lat
          lng
        }
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
